module.exports = __webpack_public_path__ + "static/media/03ilustracion.77a089d6.png";